module.exports = __webpack_public_path__ + "img/pc.04e99440.png";